import { useEffect, useState } from 'react';

import { isUserAdmin } from 'utils/internal-access';

import GoogleTagManager from '../helpers/google-tag-manager';
import { googleTagManagerId } from '../utils/envs';

const useGoogleTagManager = (userInfo) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const { isAdmin } = userInfo;

    if (isUserAdmin(isAdmin)) return;

    GoogleTagManager.boot(googleTagManagerId);

    setIsLoaded(true);
  }, [userInfo]);

  return {
    isLoaded,
  };
};

export default useGoogleTagManager;
